import {on, findAllIn, findIn, removeAttribute, setAttribute} from "@elements/dom-utils";
import axios from "axios";
import {showNotification} from '@elements/alert-notification';
import TerracePlanner from "./index";
import {translate} from '@elements/translations';
import {clearHistoryAll} from "./changeHistory";
import {refreshPage} from "./tabManager";

let backendUrl = window.location.protocol + '//' + window.location.hostname + '/r/terraceplanner/';

/**
 * initializes module vars and binds event listeners
 */
export function init () {
    let pdfButtons = findAllIn('.js-planner__download-pdf', TerracePlanner.element);

    pdfButtons.map((pdfButton) => {
        on('click', (evt) => {
            pdfListener(evt, pdfButton);
        }, pdfButton);
    });

    let newButton = findIn('.js-planner__create-new', TerracePlanner.element);
    if(newButton) {
        on('click', (evt) => {
            newTerraceListener(evt);
        }, newButton)
    }
}


export function savePlanner(name, shared) {
    TerracePlanner.terraceName = name;
    TerracePlanner.terraceShared = shared;

    let pendingRequest = axios({
        method: 'GET',
        url: backendUrl + 'save',
        params: {
            name: name,
            shared: shared
        }
    });

    pendingRequest.then(({data: {name, shareCode, shared}}) => {
        // if(!TerracePlanner.loggedIn) {
        if(shared) {
            showNotification({
                type: 'light',
                title: "<span class='icon icon-check text-success toast-header__icon'></span>" + translate('terracePlanner.shareCode.title'),
                content: translate('terracePlanner.shareCode.message') + ' ' + shareCode,
                closable: true
            });
        } else {
            showNotification({
                type: 'light',
                title: "<span class='icon icon-check text-success toast-header__icon'></span>" + translate('general.save-success'),
                closable: true
            });
        }

        TerracePlanner.shareCode = shareCode;
    });
}

/**
 * listener to invalidate the Terrace in the current session and set a new one
 *
 * @param event MouseEvent
 */
export function newTerraceListener(event) {
    clearHistoryAll();

    let xhr = new XMLHttpRequest();
    xhr.open('GET', backendUrl + 'new');
    xhr.onload = function () {
        refreshPage();
    };

    xhr.send();
}

// /**
//  * listener to ask for a name for the current terrace draft in the session and save it to the database
//  *
//  * @param event MouseEvent
//  */
// export function saveListener(event) {
//     showNamingPrompt(translate('terracePlanner.save.name'));
// }

/**
 * listener to initiate a pdf download, should only be available when the summary tab is loaded
 * and all other tabs are complete
 *
 * @param event MouseEvent
 */
export function pdfListener(event) {
    window.open(backendUrl + 'pdf', '_blank');
}

/**
 * toggles the pdfButtons' visibility
 *
 * @param visible Boolean
 */
export function setPdfVisibility (visible) {
    let pdfButtons = findAllIn('.js-planner__download-pdf', TerracePlanner.element);
    if (visible) {
        pdfButtons.map((button) => removeAttribute('hidden', button));
    } else {
        pdfButtons.map((button) => setAttribute('hidden', true, button));
    }
}